export const CARD_BASE = {
    name: 'CARD_BASE',
    path: 'img/card_base.png',
};
export const CARD_ELEMENT_BASE = {
    name: 'CARD_ELEMENT_BASE',
    path: 'img/card_element_base.png',
};

export const CARD_BASE_1 = {
    name: 'CARD_BASE_1',
    path: 'img/card_base_1.png',
};
export const CARD_BASE_2 = {
    name: 'CARD_BASE_2',
    path: 'img/card_base_2.png',
};
export const CARD_BASE_OUTLINE = {
    name: 'CARD_BASE_OUTLINE',
    path: 'img/card_base_outline.png',
};

export const IMG_SHURIKEN_BASE = {
    name: 'IMG_SHURIKEN_BASE',
    path: 'img/shuriken_base.png',
};

export const BGM_BATTLE = {
    name: 'BGM_BATTLE',
    path: require('./assets/include/sound/BGM_Battle.mp3'),
};
export const SE_BATTLE_START = {
    name: 'SE_BATTLE_START',
    path: require('./assets/include/sound/SE_BattleStart.mp3'),
};
export const SE_ATTACK = {
    name: 'SE_ATTACK',
    path: require('./assets/include/sound/SE_Attack.mp3'),
};
export const SE_CARD_MOVE = {
    name: 'SE_CARD_MOVE',
    path: require('./assets/include/sound/SE_CardMove.mp3'),
};

export const SE_CARD_PUT = {
    name: 'SE_CARD_PUT',
    path: require('./assets/include/sound/SE_CardPut.mp3'),
};

export const BACK_TOWER_01 = {
    name: 'BACK_TOWER_01',
    path: require('./assets/hash/back_tower01.jpg'),
};

export const BATTLE_SHEET = {
    name: 'BATTLE_SHEET',
    path: require('./assets/version/spritesheet/parts_battle.json'),
    tmp: require('./assets/version/spritesheet/parts_battle.png'), // requireしておかないとwebpackで取り込めない
    background: 'background_01.png',
    okiba: 'okiba.png',
    coin_haichi: 'coin_haichi.png',
    hudaokiba_01: 'hudaokiba_01.png',
    hudaokiba_02: 'hudaokiba_02.png',
    temochi: 'temochi.png',
    oku: 'oku.png',
    teki: 'teki.png',
    jibun: 'jibun.png',
};

export const HOME_SHEET = {
    name: 'HOME_SHEET',
    path: require('./assets/version/spritesheet/home.json'),
    tmp: require('./assets/version/spritesheet/home.png'), // requireしておかないとwebpackで取り込めない
    home_battle: 'home_battle.png',
    home_deck: 'home_deck.png',
    home_koji02: 'home_koji02.png',
    home_kouji01: 'home_kouji01.png',
    home_koujibase01: 'home_koujibase01.png',
    home_koujibase02: 'home_koujibase02.png',
    home_level: 'home_level.png',
    home_link: 'home_link.png',
    home_link_hedge: 'home_link_hedge.png',
    home_link_hum: 'home_link_hum.png',
    home_link_jerry: 'home_link_jerry.png',
    home_link_os: 'home_link_os.png',
    home_link_setting: 'home_link_setting.png',
    home_name: 'home_name.png',
    home_record: 'home_record.png',
    home_scroll: 'home_scroll.png',
    home_scrollbase: 'home_scrollbase.png',
    home_textframe: 'home_textframe.png',
};

export const HEADER_FOOTER_SHEET = {
    name: 'HEADER_FOOTER_SHEET',
    path: require('./assets/version/spritesheet/header_footer.json'),
    tmp: require('./assets/version/spritesheet/header_footer.png'), // requireしておかないとwebpackで取り込めない
    header: 'header.png',
    footer: 'footer.png',
    f_battle: 'f_battle.png',
    f_formation: 'f_formation.png',
    f_home: 'f_home.png',
    f_reserve: 'f_reserve.png',
    f_results: 'f_results.png',
};

export const CARD_TEAM_COLOR = {
    1 : '0x0b2b92',
    2 : '0xbc223a',
};

export const CARD_ELEMENT_ID = {
    'MOKUTON' : 1,
    'KATON' : 2,
    'DOTON' : 3,
    'KINTON' : 4,
    'SUITON' : 5,
};

export const CARD_ELEMENT_ID_TO_NAME = {
    1 : CARD_ELEMENT_ID[1],
    2 : CARD_ELEMENT_ID[2],
    3 : CARD_ELEMENT_ID[3],
    4 : CARD_ELEMENT_ID[4],
    5 : CARD_ELEMENT_ID[5],
};

export const CARD_ELEMENT_ID_TO_COLOR = {
    1 : '0x26a577',
    2 : '0xdf4a00',
    3 : '0x8c4b21',
    4 : '0xf8d108',
    5 : '0x4d95c8',
};

export const CARD_ELEMENT_VERTEX_POS = {
    0:{
        x: 0,
        y: -110,
        angle:0,
    },
    1:{
        x: 100,
        y: -30,
        angle:72,
    },
    2:{
        x: 65,
        y: 80,
        angle:144,
    },
    3:{
        x: -65,
        y: 80,
        angle:216,
    },
    4:{
        x: -100,
        y: -30,
        angle:288,
    },
};
